<template>
	<div class="mainBox">
		<div class="topNav">
			<van-nav-bar safe-area-inset-top :placeholder="true" :fixed="true" title="记事编辑" left-text="返回" left-arrow @click-left="goBack">
				
			</van-nav-bar>
		</div>
		<van-form @submit="onSubmit">
			<van-field v-model="record.recTime" readonly name="recTime" label="时间" placeholder="时间" />
			<van-field readonly clickable
				:value="record.weather"
				name="weather" 
				label="天气" 
				placeholder="请选择天气"
				:rules="[{ required: true, message: '' }]"
				@click="showWeatherPicker = true" />
			<van-popup v-model="showWeatherPicker" position="bottom">
				<van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showWeatherPicker = false" />
			</van-popup>
			<van-field
					v-model="record.temperature"
					name="temperature"
					label="温度"
					placeholder="请输入温度"
				/>
			<van-field v-model="record.recContent"
				class="textareaField"
				type="textarea"
			    autosize
			    maxlength="1000"
				name="content"
				label="内容" 
				placeholder="请填写内容" 
				:rules="[{ required: true, message: '' }]"/>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">保存</van-button>
			</div>
		</van-form>
	</div>
</template>
<script>
	import common from '../../utils/common';
	import { Notify } from 'vant';
	import { noteInfo, updateNote } from '@/api/notes';

	export default {
		name: 'notesEdit',
		data() {
			return {
				id: "",
				columns: ['晴','多云','阴','阵雨','小雨','中雨','大雨','小雪','中雪','大雪'],
				showWeatherPicker: false,
				record: {
					category: "",
					categoryName: "",
					dailyId: "",
					delFlg: "",
					list: [],
					major: "",
					majorName: "",
					weather: "",
					recContent: "",
					recMan: "",
					recTime: "",
					subjectNo: "",
					workNo: ""
				},
				user: {},
			}
		},
		mounted() {
			this.user = common.getUser();
			this.id = this.$route.query.id;
			if (this.id != '' && this.id != null && this.id != 'undefined'){
				this.getDetail(this.id);
			}
		},
		methods: {
			getDetail(id){
				noteInfo(id).then(response => {
					if(response.data.messageCode != "SUCCESS") {
						Notify({ type: 'danger', message: response.data.resultMessage });
						return
					}
					this.record = response.data.body
				})
			},
			goBack() {
				this.$router.push({
					name: 'notesList'
				});
			},
			onConfirm(value) {
				this.record.weather = value;
				this.showWeatherPicker = false;
			},
			onSubmit(data) {
				if (!common.hasPermision("noteList:edit")) {
					Notify({ type: 'danger', message: "无操作权限" });
					return;
				}
				const param = { ...this.record, recMan: this.user.username }
				updateNote(param).then(response => {
					if(response.data.messageCode === "SUCCESS") {
						Notify({ type: 'success', message: '操作成功' });
						this.goBack()
					} else {
						Notify({ type: 'danger', message: response.data.resultMessage });
					}
				})
			},
		}
	}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>
<style lang="scss" scoped>
	.mainBox {
		height: 100%;
		background-color: #ffffff;
	}
</style>